export default import.meta.ROLLDOWN_FILE_URL_0G8o7zDBHnn2cgQ8q22_zA